<template>

  <el-card>
    <div slot="header"
         class="clearfix">
      <span>疾病分析</span>
    </div>
    <el-row>
      <el-form ref="form" label-width="100px" style="display: flex;">
        <el-form-item label="数据集:">
          <el-select v-model="form.a" multiple @change="handleExport" placeholder="请选择">
            <el-option
                v-for="item in dynamicTags"
                :key="item.pk"
                :label="item.name"
                :value="item.pk">
            </el-option>
          </el-select>
        </el-form-item>
        <!--      <el-form-item label="数据集B:">
               <el-select v-model="form.b" placeholder="请选择">
                 <el-option
                    v-for="item in dynamicTags"
                   :key="item.pk"
                   :label="item.name"
                   :value="item.pk">
                 </el-option>
               </el-select>
             </el-form-item> -->
        <el-form-item label="统计工具:">
          <el-select v-model="form.gj" placeholder="请选择">
            <el-option
                label="KM生存曲线分析"
                value="km">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="统计单位:">
          <el-select v-model="form.unit" placeholder="请选择">
            <el-option
                label="年"
                value="Y">
            </el-option>
            <el-option
                label="月"
                value="M">
            </el-option>
            <el-option
                label="天"
                value="D">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <download-excel style="display:inline"
                          :data="lifelines"
                          :fields="tableDataFields"
                          type="xls"
                          name="数据导出.xls">
            <el-button type="primary"
                       style="margin-left:30px;margin-right: 10px;"
                       @click="handleExport">导出excel</el-button>
          </download-excel>
<!--          <el-button @click="handleExport" type="primary">导出</el-button>-->
          <el-button @click="handlEAnalyse" type="primary">分析</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <!--
            <el-row style="text-align: left;">
              <el-form-item >
                <el-button @click="dialogVisible = true" :disabled='setmodel' type="primary" >添加数据集</el-button>
              </el-form-item>
              <el-form-item>
                <el-radio-group @change="handClick" v-model="tag" >
                  <el-radio v-for="(item, index) in dynamicTags" :key="item.pk" border :label="item.pk">
                    {{item.name}}
                    <span @click="handleClose(item.pk,index)"><i class="el-icon-close" ></i></span>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-row>
    -->
    <div style="min-height: 300px;margin-left: -40px;margin-right: -25px;">
      <img :src="url" v-if="url"/>
      <img src="../../assets/images/shengcun2.png" v-else/>
    </div>
    <div v-if="flag">
      <el-table
          border
          :data="lifelines"
          style="width: 100%">
        <el-table-column
            prop="pk"
            label="PK"
        >
        </el-table-column>
        <el-table-column
            prop="start_time"
            label="就诊日期"
        >
        </el-table-column>
        <el-table-column
            prop="end_time"
            label="结束日期"
        >
        </el-table-column>
        <el-table-column
            prop="censored"
            label="生存状态">
        </el-table-column>
        <el-table-column
            prop="group"
            label="组">
        </el-table-column>
      </el-table>
    </div>
  </el-card>

</template>

<script>
export default {
  name: 'pinfo-charts',
  data() {
    return {
      flag:false,
      form: {
        a: [],
        gj: 'km',
        unit:'M'
      },
      lifelines: [],
      url: '',
      dynamicTags: [],
      tableDataFields:{
        "就诊日期":"start_time",
        "结束日期":"end_time",
        "状态":"censored",
        "组":"group",
      }
    }
  },
  methods: {
    xbzlchart(pk) {
      var url = '/case/dashboard/genderzl/'
      if (pk) {
        url = url + pk + '/'
      }
      this.$http.get(url).then(res => {
        this.dynamicTags = res.data.jihedata
      })
    },
    handleClose() {
      console.log('submit!')
    },
    handleExport() {
      this.$http.post('/case/lifelines/', this.form)
          .then(resp => {
            if (resp.data.code == 1) {
              this.flag = true
              this.lifelines = resp.data.data
            } else if (resp.data.code == -1) {
              this.$message({
                message: resp.data.errors,
                type: 'error'
              })
            }
          })
    },
    handlEAnalyse() {
      this.$http.post('/case/analyse/', this.form)
          .then(resp => {
            if (resp.data.code == 1) {
              this.url = resp.data.url
            } else if (resp.data.code == -1) {
              this.ondisabled = false
              this.$message({
                message: resp.data.errors,
                type: 'error'
              })
            }
          })
    }
  },
  mounted() {
    this.xbzlchart()
  }
};
</script>
